import React, {PureComponent} from "react";
import PropTypes from "prop-types";
import {Alert, Badge} from "reactstrap";
import ButterFiles from "react-butterfiles";
import {orderBy} from "lodash";
import FileRemove from "./FileRemove";
import LoadingSpinner from "../LoadingSpinner/LoadingSpinner";
import FilesLightbox from "./FilesLightbox";
import Button from "../Button";
import iconDownload from "assets/img/icon-download.webp";
import getWorkshopCurrentPlanSettings from "../../utils/getWorkshopCurrentPlanSettings";
import PlanFeatureDisabled from "../PlanFeatureDisabled";
import {toast} from "react-toastify";
import moment from "moment";
import {withTranslation} from "react-i18next";
import FileCommentFormButton from "./FileCommentFormButton";
import Icon from "../../componentsReusable/Icon";

class Files extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      filesLightboxOpen: false,
      filesLightboxPhotoIndex: 0,
      dragging: false,
      loading: false,
      errors: {},
      filesList: [],
      files: [],
    };
  }

  componentDidMount() {
    this.fetchFiles();
  }

  fetchFiles = () => {
    this.setState({
      files: [],
      loading: true,
    });
    this.props.fetchFilesFn(this.props.id)
    .then(({files}) => {
      this.setState({
        files,
        loading: false,
      });
    })
    .catch(() => {
      this.setState({
        loading: false,
      });
    })
  }

  getFilesOrdered = () => {
    return orderBy(this.state.files, 'position', 'ASC');
  }

  handleOnRemoved = (file) => {
    this.setState({
      files: this.state.files.filter(f => f.id !== file.id)
    })
  }

  handleErrors = (errors) => {
    toast.error(this.props.t('error_msg'))
  }

  handleFiles = (filesList, position) => {
    this.setState({
      filesList: [
        ...this.state.filesList,
        ...filesList,
      ]
    });

    filesList.map((file, key) => {
      const formData = new FormData();
      formData.append('file', file.src.file);
      formData.append('position', (this.state.files.length + position + key));

      this.props.postFileFn(this.props.id, formData)
      .then(data => {
        this.setState(state => {
          return {
            files: data.files,
            filesList: this.state.filesList.filter(f => f.id !== file.id)
          }
        });
      })
      .catch(e => {
        this.setState(state => {
          return {
            errors: {
              ...this.state.errors,
              [file.id]: e.response.data.children?.file?.errors.join('; '),
            }
          }
        });
      });
    });
  }

  render() {
    const {loading, filesLightboxOpen, filesLightboxPhotoIndex} = this.state;

    if(!getWorkshopCurrentPlanSettings('files')){
      return !this.props.disableLoader && <PlanFeatureDisabled />
    }

    return <div className={this.props.classNameWrapper}>
      {loading
        ? (!this.props.disableLoader && <div className="d-flex align-items-center justify-content-center"><LoadingSpinner /></div>)
        : <ButterFiles
          multiple
          maxSize="40mb"
          multipleMaxSize="100mb"
          convertToBase64
          onError={this.handleErrors}
          onSuccess={filesList =>
            this.handleFiles(filesList, this.state.filesList.length)
          }
        >
          {({ browseFiles, getDropZoneProps }) => (
            <div
              {...getDropZoneProps({
                className: (this.state.dragging ? " dragging" : ""),
                onDragEnter: () => this.setState({ dragging: true }),
                onDragLeave: () => this.setState({ dragging: false }),
                onDrop: () => this.setState({ dragging: false })
              })}
            >
              {this.props.postFileFn && (this.state.files.length === 0 && this.state.filesList.length === 0) && <Alert color="info" className="text-center mb-0 d-flex flex-column align-items-center justify-content-center">
                <Button
                  onClick={() => {
                    browseFiles({
                      onErrors: this.handleErrors,
                      onSuccess: filesList => {
                        this.handleFiles(
                          filesList,
                          this.state.filesList.length
                        );
                      }
                    });
                  }}
                >{this.props.t('no_files_btn')}</Button>
              </Alert>}

              <div className="d-flex flex-wrap" id="files-wrapper">
                {this.getFilesOrdered().map((file, index) => {
                  const fileType = file.mimeType ? file.mimeType.split('/')[0] : null;
                  return <div
                    id={`f-${file.id}`}
                    className="file position-relative"
                    key={index}
                  >
                    <div className="inner f-thumbnail bg-white p-2 d-flex align-items-center justify-content-center" onClick={() => {
                      this.setState({
                        filesLightboxPhotoIndex: index,
                        filesLightboxOpen: true,
                      })
                    }}>
                      {fileType === 'image' ? (
                        <img src={file.fileUrl} onError={({currentTarget}) => {
                          currentTarget.src = iconDownload;
                          currentTarget.style.maxWidth = '50px';
                        }} alt={file.originalName} />
                      ) : fileType === 'video' ? (
                        <div className="d-flex align-items-center justify-content-center">
                          <i className="fas fa-play-circle fa-4x text-primary" title="Odtwórz wideo"></i>
                        </div>
                      ) : (
                        <div className="d-flex align-items-center justify-content-center">
                          <i className="fas fa-file fa-4x text-secondary" title="Plik"></i>
                        </div>
                      )}
                      <div className="bottom-details shadow">
                        <div className="p-1 d-flex justify-content-between align-items-start">
                          <div>
                            <p className="mb-0 text-white">{file?.originalName ?? <span>&nbsp;</span>}</p>
                            <small className="text-light">{this.props.t('date_created')}: {moment(file.createdAt).format('YYYY-MM-DD HH:mm')}</small>
                          </div>
                          {this.props.updateFileFn && (
                            <div onClick={(e) => e.stopPropagation()} className="text-end mt-auto">
                              <FileCommentFormButton
                                file={file}
                                apiFn={this.props.updateFileFn}
                                onUpdated={updatedFile => {
                                  this.setState(prevState => ({files: prevState.files.map(f => f.id === updatedFile.id ? {...f, ...updatedFile} : f)}));
                                }}/>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                    {file.comment && <div className="comment-icon-position">
                      <Icon className="d-block fas fa-comment-alt " />
                    </div>}
                    {this.props.deleteFileFn && <FileRemove file={file} onRemoved={this.handleOnRemoved} deleteFileFn={this.props.deleteFileFn}/>}
                  </div>
                })}

                {this.state.filesList.map((file, index) => {
                  const fileType = file.src.file.type ? file.src.file.type.split('/')[0] : null;
                  return <div
                    className="file uploading"
                    key={index}
                  >
                    <div className="inner f-thumbnail bg-white p-2 d-flex align-items-center justify-content-center">
                      {fileType === 'image' ? (
                        <img src={file.src.base64} onError={({currentTarget}) => {
                          currentTarget.src = iconDownload;
                          currentTarget.style.maxWidth = '50px';
                        }} alt="Przesyłany plik" />
                      ) : fileType === 'video' ? (
                        <div className="d-flex align-items-center justify-content-center">
                          <i className="fas fa-play-circle fa-4x text-primary" title="Odtwórz wideo"></i>
                        </div>
                      ) : (
                        <div className="d-flex align-items-center justify-content-center">
                          <i className="fas fa-file fa-4x text-secondary" title="Plik"></i>
                        </div>
                      )}

                      <div className="overlay d-flex justify-content-center align-items-center">
                        <div className="bg" />
                        {this.state?.errors[file.id] ? <Badge className="mx-2 text-wrap" color="danger" style={{zIndex: 1}}>{this.state?.errors[file.id]}</Badge> : <i className="fas fa-spinner fa-spin fa-4x" />}
                      </div>
                    </div>
                  </div>
                })}

                {this.props.postFileFn && (this.state.files.length > 0 || this.state.filesList.length > 0) && <div
                  className="file"
                  onClick={() => {
                    browseFiles({
                      onErrors: this.handleErrors,
                      onSuccess: filesList => {
                        this.handleFiles(
                          filesList,
                          this.state.filesList.length
                        );
                      }
                    });
                  }}
                >
                  <div className="inner f-thumbnail bg-white p-2 d-flex align-items-center justify-content-center">
                    <i className="fas fa-plus fa-4x"/>
                  </div>
                </div>}
              </div>
            </div>
          )}
        </ButterFiles>}

        {this.state.files.length > 0 && <FilesLightbox
          files={this.getFilesOrdered()}
          isOpen={filesLightboxOpen}
          photoIndex={filesLightboxPhotoIndex}
          onClose={() => {
            this.setState({
              filesLightboxOpen: false,
            })
          }}
        />}
    </div>
  }
}

Files.defaultProps = {
  disableLoader: false,
};

Files.propTypes = {
  id: PropTypes.number.isRequired,
  classNameWrapper: PropTypes.string,
  disableLoader: PropTypes.bool,
  fetchFilesFn: PropTypes.func.isRequired,
  postFileFn: PropTypes.func,
  deleteFileFn: PropTypes.func,
  updateFileFn: PropTypes.func,
};

export default withTranslation('files')(Files)
